<template>
  <div class='layout poll-select'>
    <div class="column">
      <h1 v-if='config.title' class='title'>{{ $t(config.title, 'options.title') }}</h1>
      <h1 key='question'>{{ $t(config.question, 'options.question') }}</h1>
    </div>
    <div :class="['column multi-select-column', columnStyle]">
      <transition-group appear name='options' v-on:before-appear="beforeEnter" tag='ul' class='question-set' v-bind:css="false">
        <li role="button" :tabindex='i+1' v-on:keyup.enter.stop="select(answer)" v-bind:class='{selected: currentSelection == answer.value, "is-correct": corrects[answer.value], "is-incorrect": incorrects[answer.value]}' @click.stop='select(answer)' :key='answer.value' v-for='(answer, i) in config.answers' :data-index='i' :data-c='answer.score > 0' :data-a='answer.value' :style='buttonStyle'>
          <span class='label' v-html='$t(answer.label, `options.answers.${answer.key}.label`)'></span>
          <span :class='{"icon": true}'>
            <ion-icon name='checkmark-circle-outline'></ion-icon>
            <span class='percent'></span>
          </span>
          <span class='bar'></span>
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import Vue from 'vue'
import TranslationMixin from '../lib/TranslationMixin'

export default {
  name: 'PollSelect',
  props: ['config'],
  mixins: [TranslationMixin],
  data: function () {
    return {
      currentAnswer: null,
      currentSelection: null,
      iconStyles: {},
      corrects: {},
      incorrects: {},
      hidePercents: false,
      complete: false
    }
  },
  computed: {
    leaveDelay () {
      let d = this.config.leaveDelay || this.theme.leaveDelay || 2000
      return d
    },
    columnStyle () {
      return 'multi-select-columns-' + this.columnCount
    },
    buttonStyle () {
      return {
        borderRadius: this.theme.borderRadius + 'px'
      }
    }
  },
  methods: {
    addBackgroundImage () {
      return Object.assign({}, {backgroundImage: 'url(' + this.config.background + ')'})
    },
    select (answer) {
      if (this.complete === true) {
        return
      }
      this.complete = true
      this.currentAnswer = answer
      this.currentSelection = answer.value
      let score = answer.score || 0
      this.$store.dispatch('save',
        {
          key: this.config.key,
          answer: {
            value: this.currentSelection,
            score: score
          }
        }).then((resp) => {
        this.$emit('answer')
        this.markPollAnswers()
      })
    },
    markPollAnswers () {
      this.convince.polling(this.config.key).then(
        function (resp) {
          const children = this.$el.querySelectorAll('.question-set li')
          children.forEach(function (el, i) {
            let styleForThisItem = this.currentAnswer.value === el.dataset.a ? 'selected' : null
            let styleChanges = {}
            if (styleForThisItem) {
              styleChanges = Object.assign({}, this.theme[styleForThisItem])
            }
            let bar = el.querySelector('.bar')
            for (let key in resp.data) {
              let percent = resp.data[key].percent * 100
              if (el.dataset.a === key) {
                this.config.answers.forEach(function (answer, i) {
                  for (let key in resp.data) {
                    if (answer.value === key) {
                      el.answer = answer
                      answer.percent = percent
                    }
                  }
                })
                styleChanges = Object.assign(styleChanges, {
                  width: percent + '%'
                })
              }
            }
            let animationTime = 1000
            let options = {
              duration: animationTime,
              delay: false,
              easing: 'none'
            }
            if (i === children.length - 1) {
              options.complete = setTimeout(this.leave, this.leaveDelay)
            }
            if (styleChanges) {
              Velocity(
                bar,
                styleChanges,
                options
              )
              if (parseFloat(el.answer.percent.toFixed(0)) > 0) {
                Velocity(
                  el.querySelector('span.percent'),
                  {opacity: 1, tween: [el.answer.percent.toFixed(0), 0]},
                  {
                    duration: animationTime,
                    progress: function (elements, complete, remaining, start, tweenValue) {
                      elements[0].innerText = tweenValue.toFixed(0) + '%'
                    },
                    queue: false
                  }
                )
              } else {
                el.querySelector('span.percent').innerText = '0%'
              }
            }
          }.bind(this))
        }.bind(this)
      )
      this.hideIcons = false
    },
    leave () {
      let answer = this.currentAnswer
      this.$gtag.event('answer', {event_category: 'survey', event_label: this.config.key, value: this.currentAnswer})
      if (typeof answer.next !== 'undefined' && answer.next) {
        this.$store.commit('setIndex', this.getNext(answer.next))
      } else if (typeof this.config.next !== 'undefined' && this.config.next) {
        this.$store.commit('setIndex', this.getNext(this.config.next))
      } else {
        this.$store.commit('advance')
      }
    },
    beforeEnter: function (el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: '100%', translateZ: 0 },
        { duration: 0 }
      )
      var delay = el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el,
          { opacity: 1, translateY: '0%', translateZ: 0 },
          { complete: done, duration: 550 }
        )
      }, delay)
    },
    mergeProperties (ob, newOb) {
      for (let prop in newOb) {
        Vue.set(ob, prop, newOb[prop])
      }
    }
  },
  inject: ['convince', 'theme'],
  mounted () {
    this.currentSelection = null
    window.scroll(0, 0)
  },
  created () {
    this.hidePercents = true
    this.convince.answers = this.config.answers
    this.config.answers.forEach(function (answer, i) {
      Vue.set(answer, 'percent', null)
    })
    if (typeof this.config.columns !== 'undefined') {
      this.columnCount = this.config.columns
    } else {
      this.columnCount = 1
    }
  }
}
</script>

<style lang='scss'>
  @import '../scss/components/survey';
</style>

<style lang='scss' scoped>

span.label {
  position: static;
  z-index: 2;
}
span.icon ion-icon {
  visibility: hidden;
}
span.percent {
  opacity: 1;
  z-index:2;
}
span.bar {
  display: block;
  position:absolute;
  z-index: 1;
  left:0;
  top:0;
  bottom:0;
  width: 0%;
}
</style>
